export default "__VITE_ASSET__CRtRyhVc__"